import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import PromoComplexPopup from 'apps/promo/components/popup/PromoComplexPopup';
import { generateReferralQrLink, resolveOneLinkUrl } from 'apps/promo/helpers/oneLinkSmartScript';
import promoMedia from 'apps/promo/theme/promoMedia';
import { QRCodeSVG } from 'qrcode.react';

import { PromoButton } from '../promo-button/PromoButton';
import { PromoRow } from '../PromoRow/PromoRow';

const QR_SIZE = 136;
const QR_SIZE_TABLET = 248;

const QrCode = styled.figure`
    width: ${QR_SIZE}px;

    img,
    svg {
        border: none;
        max-width: 100%;
        vertical-align: top;
    }

    ${promoMedia.tablet744} {
        width: ${QR_SIZE_TABLET}px;
    }
`;

const QRCodePopup = (props) => {
    // Until Smart Script returns a personal link, we display a static QR from the strapi.
    const [qrLink, setQrLink] = useState(null);

    useEffect(() => {
        setQrLink(null);

        if (!props.inviteCode || !props.oneLinkUrl) return;

        let isActive = true;
        generateReferralQrLink({ oneLinkUrl: props.oneLinkUrl, inviteCode: props.inviteCode }).then((link) => {
            if (isActive) setQrLink(link);
        });

        return () => {
            isActive = false;
        };
    }, [props.oneLinkUrl, props.inviteCode]);

    return (
        <PromoComplexPopup withoutButton popupRef={props.popupRef}>
            <PromoRow indent={'16px'}>
                <PromoText color="gray80" tag="div" variant="h3">
                    {props.popupTitle}
                </PromoText>
            </PromoRow>
            <PromoRow indent={'16px'}>
                <PromoText color="gray40" tag="div" variant="subheader">
                    {props.popupSubTitle}
                </PromoText>
            </PromoRow>
            {(props.img || qrLink) && (
                <PromoRow indent={'24px'}>
                    <QrCode>
                        {qrLink && props.newOneLinkUrl ? (
                            <QRCodeSVG value={qrLink} level="H" size={QR_SIZE} bgColor="#ffffff" fgColor="#000000" />
                        ) : (
                            props.img && <img src={props.img?.[0].url} alt={''} />
                        )}
                    </QrCode>
                </PromoRow>
            )}
            <PromoRow textAlign={'right'}>
                <PromoButton caption={props.btnCaption} type={'link'} href={props.btnHref} id={'continueOnWeb'} />
            </PromoRow>
        </PromoComplexPopup>
    );
};

QRCodePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    popupTitle: PropTypes.string,
    popupSubTitle: PropTypes.string,
    img: PropTypes.array,
    inviteCode: PropTypes.string,
    oneLinkUrl: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        popupTitle: state.extra?.strapiApi?.qr_code_popup?.title,
        popupSubTitle: state.extra?.strapiApi?.qr_code_popup?.subtitle,
        img: state.extra?.strapiApi?.qr_code_popup?.img,
        btnCaption: state.extra?.strapiApi?.qr_code_popup?.btn_cta?.title,
        btnHref: state.extra?.strapiApi?.qr_code_popup?.btn_cta?.url,
        oneLinkUrl: state.extra?.strapiApi?.qr_code_popup?.btn_secondary?.url || resolveOneLinkUrl(state.extra?.strapiApi?.download_app_popup),
        newOneLinkUrl: state.extra?.strapiApi?.download_app_popup.btn_secondary.url,
    };
};
export default connect(mapStateToProps, null)(QRCodePopup);
